// config/teacherPermissions.js
// Centralized configuration for teacher permissions
// Easy to modify and extend for future role-based permissions

export const TEACHER_PERMISSIONS = {
  // Dashboard access
  canAccessDashboard: true,
  dashboardPath: '/teacher-dashboard',
  
  // Student management
  students: {
    canView: true,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canArchive: false,
    
    // Financial-related features to hide
    hideFinancialColumns: true, // Hide المدفوع, الرسوم, etc.
    hideFinancialFilters: true, // Hide الطلاب غير المسددين, دفع رسوم الملابس, etc.
    hideFinancialActions: true, // Hide payment buttons, etc.
    
    // API data to exclude
    excludeFinancialData: true, // Don't fetch payment_summary, recipients, etc.
  },
  
  // Financial pages
  financial: {
    canAccess: false,
    canViewPayments: false,
    canViewRecipients: false,
    canCreatePayments: false,
  },
  
  // Schedule
  schedule: {
    canView: true,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    isReadOnly: true,
  },
  
  // Classes
  classes: {
    canView: true, // Only classes where teacher is responsible
    canCreate: false,
    canEdit: false,
    canDelete: false,
  },
  
  // Subjects
  subjects: {
    canView: true, // Only subjects assigned to teacher
    canCreate: false,
    canEdit: false,
    canDelete: false,
  },
  
  // Substitute teachers
  substituteTeachers: {
    canView: false,
  },
  
  // Staff management
  staff: {
    canView: false,
    canCreate: false,
    canEdit: false,
  },
  
  // Buses
  buses: {
    canView: false,
  },
  
  // Store
  store: {
    canView: false,
  },
  
  // Archive
  archive: {
    canView: false,
  },
  
  // Administrative
  admin: {
    canAccess: false,
    canManageUsers: false,
    canViewLogs: false,
    canAccessSettings: false,
  },
};

// Helper function to check if current user is teacher
export const isTeacher = () => {
  return localStorage.getItem('role') === 'teacher';
};

// Helper function to check permission
export const hasPermission = (category, permission) => {
  if (!isTeacher()) {
    return true; // Non-teachers have full access (subject to other permissions)
  }
  
  const categoryPerms = TEACHER_PERMISSIONS[category];
  if (!categoryPerms) {
    return false;
  }
  
  return categoryPerms[permission] === true;
};

// Helper to get teacher dashboard path
export const getTeacherDashboardPath = () => {
  return isTeacher() ? TEACHER_PERMISSIONS.dashboardPath : '/dashboard';
};
